import React from "react";
import _ from "lodash-es";
import currencyText from "./currencyText";
import { injectIntl } from "react-intl";
import { withMainContext } from "../../hoc/withMainContext";

const CurrencySpan = ({
  value,
  textColor,
  currencyId,
  // currency,
  intl,
  strong,
  currencies,
  digit,
  showNull
}) => {
  // console.log("CurrencySpan", value, textColor, currency);

  const style = strong !== undefined ? { fontWeight: "bold" } : {};
  return (
    //<div>
    <span className={textColor} style={style}>
      {value || !!showNull
        ? currencyText(
            _.find(currencies, {
              id: currencyId
            }),
            value,
            intl.locale,
            digit
          )
        : ""}
    </span>
    //</div>
  );
};

// export default injectIntl(CurrencySpan);
export default injectIntl(withMainContext(CurrencySpan));
